<template>
  <QDialog v-model="showDialog">
    <QCard class="lease-inclusion-dialog full-width q-pa-md" style="max-width: 1024px">
      <QCardSection class="column items-center q-pa-none q-ma-none full-width scroll">
        <QCardSection class="column q-pa-none full-width">
          <QBtn
            rounded
            class="calculator-dialog-close"
            flat
            :icon-right="closeIconCircle"
            size="16px"
            color="primary"
            align="left"
            @click="handleClose"
          >
            Close
          </QBtn>

          <QCardSection class="lease-inclusion-footer column full-width" style="max-width: 870px">
            <p class="font-nunito text-grey-8 mb-0" style="font-size: 15px; margin-bottom: 0">{{ content }}</p>
          </QCardSection>
        </QCardSection>
      </QCardSection>
    </QCard>
  </QDialog>
</template>

<script>
import { QDialog, QCard, QCardSection, QBtn } from 'quasar';
import { evaCloseCircleOutline } from '@quasar/extras/eva-icons';
import { mapGetters } from 'vuex';

export default {
  props: {
    value: Boolean
  },
  name: 'InformationModal',
  data: function () {
    return {
      showDialog: false,
      closeIconCircle: evaCloseCircleOutline
    };
  },
  created() {
    this.showDialog = this.value;
  },
  computed: {
    ...mapGetters({
      orgProfile: 'theme/getOrgProfile'
    }),
    isNZ() {
      const countryCode = this.orgProfile?.region || 'NZ';
      return countryCode === 'NZ';
    },
    content() {
      const NZ_CONTENT =
        '‘RRP’ is the Recommended Retail Price advertised by the vehicle manufacturer. RRP includes GST and excludes on-road costs.';
      const AU_CONTENT =
        '‘RRP’ is the Recommended Retail Price advertised by the vehicle manufacturer. RRP includes GST and excludes on-road costs.';
      return this.isNZ ? NZ_CONTENT : AU_CONTENT;
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val, oldVal) {
        this.showDialog = this.value;
        // do your stuff
      }
    }
  },
  methods: {
    handleClose() {
      this.showDialog = false;
      this.$emit('onClose', false);
    }
  },
  components: {
    QDialog,
    QCard,
    QCardSection,
    QBtn
  }
};
</script>
